// extracted by mini-css-extract-plugin
export default {"first":"#000","second":"#09f755","tmain":"#fff","tsecond":"#797575"};